import React from 'react';
import { Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { resolveImage } from '../utils/imageHelper';

const TopApps = () => {
  const { topApps } = useSite();
  if (!topApps || topApps.length === 0) return null;

  return (
    <section className="w-full bg-white border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-3 py-5">
        <div className="grid grid-cols-3 gap-3 sm:gap-6">
          {topApps.slice(0, 3).map((app) => (
            <div key={app.id} className="flex flex-col items-center text-center">
              <Link to={`/app/${app.slug}`} className="block">
                <img
                  src={resolveImage(app.image)}
                  alt={app.name}
                  className="w-20 h-20 sm:w-28 sm:h-28 rounded-xl object-cover shadow-md hover:scale-105 transition-transform duration-200"
                  loading="lazy"
                />
              </Link>
              <Link
                to={`/app/${app.slug}`}
                className="mt-2 text-xs sm:text-sm font-medium text-gray-800 hover:text-[#6a1b7d] transition-colors"
              >
                {app.name}
              </Link>
              <Link
                to={`/app/${app.slug}`}
                className="mt-2 inline-flex items-center gap-1.5 bg-[#0f8a4a] hover:bg-[#0b6f3b] text-white text-xs sm:text-sm font-medium px-3 py-1.5 rounded-md shadow transition-colors"
              >
                <Download className="w-3.5 h-3.5" />
                Download
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopApps;
